import api from '../utils/axiosConfig';

const BASE_URL = '/preferences';

export const submitPreferences = async (preferences) => {
  const response = await api.post(`${BASE_URL}/submit/`, preferences);
  return response.data;
};

export const getUserPreferences = async () => {
  const response = await api.get(`${BASE_URL}/personal/preferences/`);
  return response.data;
};

export const setCompanyShortlists = async (shortlists) => {
  const response = await api.patch(`${BASE_URL}/pu_admin/set_company_shortlists/`, shortlists);
  return response.data;
};

export const exportPlacementData = async () => {
  const response = await api.get(`${BASE_URL}/pu_admin/export_placement_data/`, {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }
  });
  
  const contentDisposition = response.headers['content-disposition'];
  let filename = 'placement_data.xlsx';
  
  if (contentDisposition) {
    const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
    if (filenameMatch?.[1]) {
      filename = filenameMatch[1].replace(/['"]/g, '');
    }
  }
  
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
  
  return { message: 'Export successful' };
};

export const downloadPreferenceTemplate = async () => {
  const response = await api.get(`${BASE_URL}/pu_admin/download_preference_template/`, {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }
  });
  
  const contentDisposition = response.headers['content-disposition'];
  let filename = 'student_preference_template.xlsx';
  
  if (contentDisposition) {
    const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
    if (filenameMatch?.[1]) {
      filename = filenameMatch[1].replace(/['"]/g, '');
    }
  }
  
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
  
  return { message: 'Template downloaded successfully' };
};

export const uploadStudentPreferences = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  
  const response = await api.post(`${BASE_URL}/pu_admin/upload_student_preferences/`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  
  return response.data;
};